import TwoColumnContent from './TwoColumnContent'

export default TwoColumnContent
